import type { ElementRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';

import type { Variants } from '../variant/variant';
import { ComponentVariant } from '../variant/variant';

@Component({
  selector: 'rt-truncate',
  templateUrl: './truncate.component.html',
  styleUrls: ['./truncate.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
  standalone: true,
})
export class TruncateComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'fade']];
  @ComponentVariant(TruncateComponent.VARIANTS)
  @Input()
  public variant: string;

  @ViewChild('spanElement', { static: true })
  public spanElement: ElementRef<HTMLSpanElement>;

  public isTruncated = () => {
    const span = this.spanElement.nativeElement;
    return span.offsetWidth < span.scrollWidth;
  };
}
